import gcoord from 'gcoord';
import { message } from 'antd';
import { faultCodeData } from '@/constants/faultCode';
import { registerClipboard } from '@/utils//common';
import { formatTime } from '@/utils/formatTime';
import { carDetailRequest } from '@/service/carManage';
// import carIcon from '@/assets/image/carIcon.png';
// import onlineCarIcon from '@/assets/image/onlineCarIcon.png';
// import abnormalCarIcon from '@/assets/image/abnormalCarIcon.png';
// import highAbnormalCarIcon from '@/assets/image/highAbnormalCarIcon.png';

// 每个 Marker 必须拥有独立的 BMap.Icon 实例。
// BMap.Icon 内部持有 img DOM 元素，MarkerClusterer 聚合/展开时会操作 DOM，
// 如果多个 Marker 共享同一个 Icon 实例，展开后 img 元素会被抢占导致图标丢失。
// 性能影响可忽略：BMap.Icon 本身是轻量 JS 对象，实际图片仅 4 张由浏览器缓存。
const createBMapIcon = (iconUrl: string) => {
    return new window.BMap.Icon(iconUrl, new window.BMap.Size(32, 32), {
        imageSize: new window.BMap.Size(32, 32),
        anchor: new window.BMap.Size(16, 16),
    });
    // return new window.BMap.Icon(iconUrl, new window.BMap.Size(28, 28));
    // return new window.BMap.Icon(iconUrl, new window.BMap.Size(128, 128));
};

const createMarkerLabel = (plateNumber: string) => {
    const label = new window.BMap.Label(plateNumber, {
        offset: new window.BMap.Size(-18, -25)
    });
    label.setStyle({
        color: "#000",
        backgroundColor: "#fff",
        fontSize: "12px",
        border: "1px solid #000",
        padding: "0 2px"
    });
    return label;
};

// 车辆分布中获取设备异常等级
export const getAbnormalDeviceLevel = (
    deviceStatus: any,
    judegeCount: number
) => {
    const abnormalLevel = {
        abnormal: false,
        highAbnormal: false
    };
    if (Array.isArray(deviceStatus)) {
        // 车辆分布接口设备状态为数组形式处理
        deviceStatus.forEach(item => {
            if (Number(item.code) !== 0) {
                if (item.count > 0) {
                    abnormalLevel.abnormal = true;
                }
                if (item.count >= judegeCount) {
                    abnormalLevel.highAbnormal = true;
                }
            }
        });
    } else if (deviceStatus !== '0') {
        // 车辆列表接口设备状态为字符串形式处理
        abnormalLevel.abnormal = true;
    }
    return abnormalLevel;
};

// 复制车辆位置链接
export const copyLocationLink = (locationLink: string, carInfoWindow: any) => {
    function copy() {
        const copyLinkButtonDom: any = document.getElementById("copyLinkButton")
        if (!copyLinkButtonDom) return;
        copyLinkButtonDom.onclick = function () {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(locationLink).then(() => {
                    message.success('复制成功');
                }, (err) => {
                    message.error('复制失败');
                });
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = locationLink;
                textArea.style.position = "fixed";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand('copy');
                    message.success('复制成功');
                } catch (err) {
                    message.info('浏览器不支持，请手动复制');
                }
                document.body.removeChild(textArea);
            }
        }
    }

    if (!carInfoWindow.isOpen()) {
        // BMap 中 Infowindow 需要通过 map.addEventListener('infowindowopen') 来监听，或者可以直接执行，我们在使用的地方稍微改变一下逻辑，如果传了 isOpen 我们可以直接调用
        carInfoWindow.addEventListener("open", function () {
            copy()
        })
    } else {
        copy()
    }
}

// 点击汽车点位展示汽车信息
export const showCarInfoBMap = async (
    info: any,
    carLnglat: any,
    map: any,
    judegeCount: number,
    copyButtonId: string
) => {
    const plateNumber = info.plate_number;
    const isKls = info?.isKls || false;
    const deviceStatus = info.device_status;
    let content = `<div style="max-width: 300px; font-size: 12px">车牌号：${plateNumber}`;
    // 注意百度外链的经纬度顺序是 lat,lng
    const locationLink = `http://api.map.baidu.com/marker?location=${carLnglat.lat},${carLnglat.lng}&title=${plateNumber}&content=${plateNumber}&output=html`;
    // 根据id获取车辆详细数据
    if (info.id) {
        const res = await carDetailRequest(info.id);
        const carDetail = res.data?.data || {};
        const {
            sn,
            adas_sn,
            online,
            adasOnline,
            online_at,
            adas_online_at,
            cate_path_name,
            car_principal,
            car_principal_phone,
            car_driver,
            car_driver_phone,
            versionInfo
        } = carDetail;
        // 处理设备状态的显示
        if (deviceStatus) {
            let deviceStatusString = '';
            let deviceStatusCountString = '';
            const isAbnormalDevice = getAbnormalDeviceLevel(
                deviceStatus,
                judegeCount
            ).abnormal;
            if (isAbnormalDevice) {
                if (Array.isArray(deviceStatus)) {
                    // 车辆分布接口设备状态为数组形式处理
                    deviceStatus.forEach((item: any) => {
                        const code = item.code;
                        if (Number(code) !== 0) {
                            const matchString = faultCodeData[code];
                            if (deviceStatusString) {
                                deviceStatusString += '，';
                                deviceStatusCountString += '，';
                            }
                            deviceStatusString += matchString || code;
                            deviceStatusCountString += `故障码${code}：${item.count}次`;
                        }
                    });
                    if (deviceStatusString) {
                        content += `<br>设备状态: ${deviceStatusString}<br>${deviceStatusCountString}`;
                    }
                } else if (deviceStatus !== '0') {
                    // 车辆列表接口设备状态为字符串形式处理
                    const matchString = faultCodeData[deviceStatus];
                    deviceStatusString += matchString || deviceStatus;
                    content += `<br>设备状态: ${deviceStatusString}`;
                }
            } else {
                content += `<br>设备状态: 正常`;
            }
        }
        content += `<br>是否在线: ${isKls ? online : adasOnline}`;
        content += `<br>最后一次在线时间: ${isKls ? formatTime(online_at) : formatTime(adas_online_at)}`;
        content += `<br>设备SN: ${isKls ? sn : adas_sn}`;
        if (isKls) { //只有kls设备显示版本信息
            content += `<br>版本信息: ${versionInfo || '未知'}`;
        }
        if (car_principal) {
            content += `<br>负责人: ${car_principal}`;
        }
        if (car_principal_phone) {
            content += `<br>负责人电话: ${car_principal_phone}`;
        }
        if (car_driver) {
            content += `<br>司机: ${car_driver}`;
        }
        if (car_driver_phone) {
            content += `<br>司机电话: ${car_driver_phone}`;
        }
        content += `<br>分组: ${cate_path_name}`;
    }
    content += `<br>地址链接: <a target='_blank' href="${locationLink}">跳转到地址链接</a><button data-clipboard-text="${locationLink}" id=${copyButtonId}>复制链接</button></div>`;

    // 车辆信息的显示 (BMap InfoWindow)
    const carInfoWindow = new window.BMap.InfoWindow(content, {
        width: 0,
        height: 0,
        offset: new window.BMap.Size(0, -28)
    });

    // BMapInfoWindow 打开的时候，绑定复制事件
    carInfoWindow.addEventListener("open", function () {
        // 稍作延迟确保 DOM 被渲染
        setTimeout(() => {
            const copyLinkButtonDom: any = document.getElementById(copyButtonId);
            if (!copyLinkButtonDom) return;
            copyLinkButtonDom.onclick = function () {
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(locationLink).then(() => {
                        message.success('复制成功');
                    }, (err) => {
                        message.error('复制失败');
                    });
                } else {
                    const textArea = document.createElement("textarea");
                    textArea.value = locationLink;
                    textArea.style.position = "fixed";
                    document.body.appendChild(textArea);
                    textArea.focus();
                    textArea.select();
                    try {
                        document.execCommand('copy');
                        message.success('复制成功');
                    } catch (err) {
                        message.info('浏览器不支持，请手动复制');
                    }
                    document.body.removeChild(textArea);
                }
            }
            registerClipboard(copyButtonId);
        }, 100);
    });

    const closeInfoWindowOnZoom = () => {
        map.closeInfoWindow();
    };
    map.addEventListener('zoomend', closeInfoWindowOnZoom);
    carInfoWindow.addEventListener('close', () => {
        map.removeEventListener('zoomend', closeInfoWindowOnZoom);
    });

    map.openInfoWindow(carInfoWindow, carLnglat);
};

// 绘制地图上的车辆点位
export const drawCarBMap = (
    carLocation: any,
    map: any,
    judegeCount: number,
    copyButtonId: string,
    judgeLocationFunc?: any
) => {
    const BMapLib = window.BMapLib;
    const points: any[] = [];
    const markers: any[] = [];
    const filterCarLocation = [];

    for (let i = 0; i < carLocation.length; i++) {
        const currCarLocation = carLocation[i];
        const { device_status, lat, lon } = currCarLocation;
        // 获取设备故障等级
        const abnormalDeviceLevel = getAbnormalDeviceLevel(
            device_status,
            judegeCount
        );
        // 转换坐标系
        if (lat && lon) {
            // 有判断条件时执行判断条件
            if (
                judgeLocationFunc &&
                !judgeLocationFunc(abnormalDeviceLevel, currCarLocation)
            ) {
                continue;
            }
            // WGS84 转 BD09
            const transformGcoord = gcoord.transform(
                [lat, lon],
                gcoord.WGS84,
                gcoord.BD09
            );

            const point = new window.BMap.Point(transformGcoord[0], transformGcoord[1]);
            points.push({
                point: point,
                carData: { ...currCarLocation, abnormalDeviceLevel }
            });
            filterCarLocation.push(currCarLocation);
        }
    }

    for (let i = 0; i < points.length; i++) {
        const carData = points[i].carData;
        const point = points[i].point;
        // let iconObj = carData.online ? onlineCarIcon : carIcon;
        let iconObj = carData.online ? '/images/map/onlineCarIcon.png' : '/images/map/carIcon.png';


        if (carData.abnormalDeviceLevel.abnormal) {
            // 区分故障次数分级显示不同的图标
            iconObj = carData.abnormalDeviceLevel.highAbnormal
                ? '/images/map/highAbnormalCarIcon.png'
                : '/images/map/abnormalCarIcon.png';
        }

        // 每个 Marker 创建独立的 BMap.Icon，避免聚合展开时图标丢失
        const customIcon = createBMapIcon(iconObj);

        const marker = new window.BMap.Marker(point, { icon: customIcon });

        marker.setLabel(createMarkerLabel(carData.plate_number));

        marker.addEventListener('click', () => {
            showCarInfoBMap(carData, point, map, judegeCount, copyButtonId);
        });
        markers.push(marker);
    }

    // BMapLib.MarkerClusterer 实例化
    const markerClusterer = new BMapLib.MarkerClusterer(map, { markers: markers });

    // MarkerClusterer 在缩放重绘时会重新处理 marker，label 可能被移除，需要补挂回去。
    const prevZoomendHandler = map.__carLocationLabelZoomendHandler;
    if (prevZoomendHandler) {
        map.removeEventListener('zoomend', prevZoomendHandler);
    }
    const restoreLabelsOnZoomend = () => {
        markers.forEach((marker, index) => {
            marker.setLabel(createMarkerLabel(points[index].carData.plate_number));
        });
    };
    map.__carLocationLabelZoomendHandler = restoreLabelsOnZoomend;
    map.addEventListener('zoomend', restoreLabelsOnZoomend);

    // 百度地图点聚合默认会放大，或者可以自己监听点击事件进行其他处理

    // 返回要展示的车辆信息以及聚合点信息
    return {
        filterCarLocation,
        markerClusterer
    };
};
